module.exports = __webpack_public_path__ + "img/Pets Family.fb0d2174.svg";